import React from 'react'
import { render, screen } from '@testing-library/react'
import InformationCard from '../InformationCard'
import { InformationCardProps } from '../types.d'

const baseProps: InformationCardProps = {
  children: [
    {
      listItems: [
        { col1: 'Lorem ipsum dolor sit amet', col2: '' },
        { col1: 'Lorem ipsum dolor sit amet', col2: '' },
        { col1: 'Lorem ipsum dolor sit amet', col2: '' }
      ]
    }
  ],
  ctaLabel: 'CTA Label',
  ctaLink: '#CTA-Link',
  icon: [
    {
      url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/icons/utility/thumbs-up.svg'
    }
  ],
  linkIcons: '',
  listStyles: 'list-checkmark-orange',
  paddingMatrix: [
    {
      paddingTop: '24',
      paddingRight: 'null',
      paddingBottom: 'null',
      paddingLeft: '24',
      mobileTop: '16',
      mobileRight: '24',
      mobileBottom: 'null',
      mobileLeft: '16'
    }
  ],
  sectionDescription: {
    raw: JSON.stringify({
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Section Description',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    })
  },
  sectionHeading: 'Heading',
  subtitle: 'Subtitle',
  textAlignment: 'left'
}

describe('Information Card Tests', () => {
  it('Should Render InformationCard with Icon, White BG, No Border, and Flat Elevation', () => {
    render(<InformationCard {...baseProps} />)

    // Get InformationCard container element by class name
    const informationcard = screen.getByTestId('InformationCard-1')
    expect(informationcard).toBeTruthy()
    expect(informationcard).toHaveClass(
      'bg-white',
      'shadow-md',
      'text-left',
      'md:pt-6',
      'md:pb-6',
      'md:pl-6',
      'md:pr-6',
      'pt-4',
      'pb-6',
      'pl-4',
      'pr-6'
    )
  })

  it('Should render the Icon, Heading, Subtitle, Description, List, and Link', () => {
    render(<InformationCard {...baseProps} />)
    // Get Object element By TestId Icon
    const iconSVG = screen.getByTestId('Image')
    expect(iconSVG).toBeTruthy()

    // Get H3 element
    const heading = screen.getByRole(`heading`, { level: 4 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-default')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element By TestId subheading
    const subheading = screen.getByTestId('subheading')
    expect(subheading).toBeTruthy()
    expect(subheading.textContent).toBe('Subtitle')

    // Get Paragraph element By TestId description
    expect(screen.getByText('Section Description')).toBeTruthy()

    // Get List element By TestId list
    const items = screen.getAllByRole('listitem')
    expect(items.length).toBe(3)

    // Get Link element By Role Link
    const cta = screen.getByRole(`link`)
    expect(cta).toBeTruthy()
    expect(cta).toHaveAttribute('href', '#CTA-Link')
    expect(cta.textContent).toContain('CTA Label')
  })
})
